function fontStyles(theme) {
  return function () {
    return {
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      fontFamily: theme.fontFamily || "sans-serif"
    };
  };
}

export { fontStyles };